import { inject, injectable } from 'inversify';
import { Store } from 'vuex';
import { DEPENDENCIES } from '../container/dependencies.const';
import { EmpathyXConfig } from '../models/config';
import { GETTERS_KEYS, RootStoreState } from '../store';
import { PositionService } from './services.types';

@injectable()
export class DefaultPositionService implements PositionService {

  @inject(DEPENDENCIES.Store)
  protected readonly store: Store<RootStoreState>;

  getCorePosition(coreStyles: Partial<CSSStyleDeclaration>): Partial<CSSStyleDeclaration> {
    const clientHeaderPosition: Partial<CSSStyleDeclaration> = this.getClientHeaderPosition();
    Object.assign(coreStyles, clientHeaderPosition);
    return coreStyles;
  }

  protected getClientHeaderSelector(): string {
    const { core }: EmpathyXConfig = this.store.getters[GETTERS_KEYS.config.config];
    return core.position.clientHeaderSelector;
  }

  protected getClientHeaderPosition(): Partial<CSSStyleDeclaration> {
    const headerSelector = this.getClientHeaderSelector();
    if (headerSelector) {
      const header = document.querySelector(headerSelector);
      if (header) {
        const boundingRect = header.getBoundingClientRect();
        const empathyXtop = boundingRect.top + boundingRect.height;
        return { top: `${ empathyXtop }px`, height: `calc(100% - ${ empathyXtop }px)` };
      }
    }
    return {};
  }
}
